// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import { addCommas } from '../../../utils/commonUtils';

type MutableEventTarget = {
  defaultValue: string,
};

const removeNonNumericWithoutMinus = num =>
  num.toString().replace(/[^0-9^-]/g, '');

export default class ConvertibleEquityView extends JQueryView {
  constructor() {
    super('.modal-body');
  }

  @on({
    event: 'change',
    selector: 'input[type="radio"][name="right_type"]',
  })
  onClickRightTypeRadioButton(event: Event) {
    // 2種のフォームの表示/非表示を切り替え
    const rightTypePanelTable = {
      convertible_equity: 'convertible-equity-panel',
      basic: 'basic-panel',
    };
    // $FlowFixMe
    const mutableEventTarget = (event.target: MutableEventTarget);

    $('#convertible-equity-panel').addClass('d-none');
    $('#basic-panel').addClass('d-none');
    $(`#${rightTypePanelTable[mutableEventTarget.defaultValue]}`).removeClass(
      'd-none',
    );

    // フォーム外のrightTypeの選択した値を2種のフォームのrightTypeに設定
    $('input[name="share_type_right_type[right_type]"]').val(
      mutableEventTarget.defaultValue,
    );
  }

  @on({
    event: 'change',
    selector:
      'input[type="radio"][name="share_type_right_type[cap_valuation_type]"]',
  })
  onClickCapValuationTypeRadioButton(event: Event) {
    const capValuationLabelTable = {
      pre: 'Preキャップバリュエーション',
      post: 'Postキャップバリュエーション',
    };
    // $FlowFixMe
    const mutableEventTarget = (event.target: MutableEventTarget);

    $('#convertible_equity_share_type_right_type_cap_valuation_amount')
      .parent()
      .find('label')[0].innerText =
      capValuationLabelTable[mutableEventTarget.defaultValue];
  }
  @on({
    event: 'input',
    selector: 'input.js-comma-numeric',
  })
  onInputCommaNumeric(event: Event) {
    const eventTarget = $(event.target);
    eventTarget.val(addCommas(removeNonNumericWithoutMinus(eventTarget.val())));
  }
}
